import { CommentOutlined, ExpandMoreOutlined } from '@mui/icons-material';

import type { Dispatch, SetStateAction } from 'react';

import { tss } from 'tss-react/mui';

import { Or2Button } from '@/components/button/Or2Button';
import { graphql, type DocumentType } from '@/gql';

const POST_COMMENT_BUTTON_COMMENT_FRAGMENT = graphql(`
  fragment postCommentButtonCommentFields on PostComment {
    _id
    content
    created
    author {
      ...authorData
    }
  }
`);

interface Props {
  comments: Array<DocumentType<typeof POST_COMMENT_BUTTON_COMMENT_FRAGMENT>>;
  showComments: boolean;
  setShowComments: Dispatch<SetStateAction<boolean>>;
}

const useStyles = tss.create(({ theme }) => ({
  expand: {
    transform: 'rotate(0deg)',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
    marginLeft: 'auto',
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

export const PostCommentButton = ({
  comments,
  showComments,
  setShowComments,
}: Props) => {
  const { classes, cx } = useStyles();

  const showCommentCount = showComments || comments.length;

  return (
    <Or2Button
      color="secondary"
      size="small"
      startIcon={<CommentOutlined />}
      endIcon={
        showCommentCount ? (
          <ExpandMoreOutlined
            className={cx(classes.expand, {
              [classes.expandOpen]: showComments,
            })}
          />
        ) : null
      }
      onClick={() => setShowComments((showComments) => !showComments)}
      sx={{ width: '10.6em' }}
    >
      {showCommentCount ? comments.length : 'Comment'}
    </Or2Button>
  );
};
